import React, { Component } from 'react';
import {
    Card, CardBody, Row, Col, Button, FormGroup, Input, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter, Label
} from "reactstrap";
import validator from 'validator';
import Select from 'react-select';
// import DayPickerInput from 'react-day-picker/DayPickerInput';
import { countryCode } from "./../../redux/utils/countryCode";
import { LangValidation } from "../../lang/en/validation";
import dateFnsFormat from 'date-fns/format';
import axios from "axios";
import SaveLoader from "../../components/loader/SaveLoader";
import { EN_Month, FA_Month } from "./formconfig";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import { API_URL, options } from '../../config/Config';
import momentJalaali from 'moment-jalaali';



class PassengerForm extends Component {
    constructor(props) {
        super(props);
        this.handleRegister.bind(this);
        this.handleChange.bind(this);
        this.handleValidation.bind(this);
        this.handleChangeCountry.bind(this);
        this.handleBlur.bind(this);
        this.toggle = this.toggle.bind(this);

        this.state = {
            fields: {
                "PassengerType": 1,//Adult = 1, Child = 2, Infant = 3
                "name": "",
                "family": "",
                "Gender": 1,//Male = 1,Female = 2
                "BirthDate": "",
                "DocType": 1,//Passport = 1,NationalId = 4,
                "nationalId": "",
                "passportId": "",
                "passportExpire": "",
                "DocIssuedCountry": "",//country iso code
                // id: null
            },
            errors: {},
            loading: false,
            country: [],
            selectedOption: {
                value: "IR",
                label: "Iran"
            },
            PassengerType: {
                1: "Adult",
                2: "Child",
                3: "Infant",
            },
            addPassenger: [],
            modal: false,
            birthdayyear: '1397',
            birthdaymonth: '01',
            birthdayday: '31',
            passexyear: '2020',
            passexmonth: '01',
            passexday: '01',
            columnDefs:
                [{
                    name: "No.",
                    options: {
                        filter: false,
                        sort: false,
                    }
                },
                {
                    name: "First Name",
                    options: {
                        filter: true,
                        sort: true,
                    }
                },
                {
                    name: "Last Name",
                    options: {
                        filter: true,
                        sort: true,
                    }
                },
                {
                    name: "Select",
                    options: {
                        filter: false,
                        sort: false,
                    }
                }],
            rowData: [],
            defaultyear: 0,
            defaultmonth: 0,
            defaultday: 0,
        }
    }
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    async componentWillMount() {
        let country = await countryCode.map(item => {
            return {
                value: (item.symbol).substring(0, 2),
                label: item.NAME
            };
        });

        this.setState({ country, fields: this.props.data })
    }
    async componentDidMount() {
        const { review, data } = this.props;
        if (review === true) {
            // console.log('yyy')
            // console.log(data);
            let selectedOption = countryCode.filter(item => item.symbol.substring(0, 2) === data.DocIssuedCountry)[0];

            await this.setState({
                fields: {
                    "PassengerType": data.PassengerType,//Adult = 1, Child = 2, Infant = 3
                    "name": data.name,
                    "family": data.family,
                    "Gender": data.Gender,//Male = 1,Female = 2
                    "BirthDate": data.BirthDate,
                    "DocType": data.DocType,//Passport = 1,NationalId = 4,
                    "nationalId": data.nationalId,
                    "passportId": data.passportId,
                    "passportExpire": data.passportExpire,
                    "DocIssuedCountry": data.DocIssuedCountry,//country iso code
                    "id": null
                },
                selectedOption: {
                    value: data.DocIssuedCountry,
                    label: selectedOption.NAME
                }
            })
        }
        // console.log(data.passportExpire)
    }

    render() {
        const {
            // index,
            data,
            review
        } = this.props;
        const { fields } = this.state;
        let errors = this.state.errors;
        // console.log("this.props.errors")
        // console.log(this.props.errors)
        if (review === false) {
            let pErrors = this.props.errors;
            if (Object.keys(pErrors).length > 0) {
                errors = pErrors;
            } else {
                errors = {}
            }
        }

        // console.log(fields)
        // console.log(errors)

        return (
            <div>
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Card className="white mb-3 w-100 flight-item ticket-pasenger-cards">
                    <CardBody>
                        <div className="form-section">
                            <Row className="b">
                                <Col md={6} className="text-left text-bold pt-2 green-text">
                                    <h4> <i className={(data.PassengerType === 1) ? "la la-male" : "la la-child"} />{this.state.PassengerType[data.PassengerType]}</h4>
                                </Col>
                                <Col md={6} className="text-left text-bold">
                                    {this.props.user !== null &&
                                        <Button color="info" outline className="pull-right" onClick={this.addPassenger.bind(this)} >
                                            <i className="la la-user-plus " /> add from passengers List
                                        </Button>
                                    }
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col md={3} sm={6}>
                                <FormGroup>
                                    <Label for="name">Name</Label>
                                    <Input
                                        invalid={("name" in errors)}
                                        name="name"
                                        type="text"
                                        placeholder="Name"
                                        value={fields.name}
                                        onChange={this.handleChange.bind(this)}
                                        onBlur={this.handleBlur.bind(this)}
                                    />
                                    <FormFeedback style={{ color: "red" }}>{errors.name}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={3} sm={6}>
                                <FormGroup>
                                    <Label for="name">Family</Label>
                                    <Input
                                        invalid={("family" in errors)}
                                        name="family"
                                        type="text"
                                        placeholder="Family"
                                        value={fields.family}
                                        onChange={this.handleChange.bind(this)}
                                        onBlur={this.handleBlur.bind(this)}
                                    />
                                    <FormFeedback style={{ color: "red" }}>{errors.family}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={3} sm={6}>
                                <FormGroup>
                                    <Label for="gender">Gender</Label>
                                    <Input
                                        type="select"
                                        name="Gender"
                                        placeholder="Gender"
                                        value={fields.Gender}
                                        onChange={this.handleChange.bind(this)}
                                        onBlur={this.handleBlur.bind(this)}
                                    >
                                        <option value={1}>Male</option>
                                        <option value={2}>Female</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={3} sm={6}>
                                <FormGroup>
                                    <Label for="name">Doc Issued Country : </Label>
                                    <Select
                                        className="select-country"
                                        placeholder="Doc Issued Country"
                                        // isClearable={true}
                                        isSearchable={true}
                                        name="DocIssuedCountry"
                                        defaultValue={this.state.selectedOption}
                                        value={this.state.selectedOption}
                                        onChange={this.handleChangeCountry.bind(this)}
                                        blur={this.handleBlur.bind(this)}
                                        options={this.state.country}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5} sm={6}>
                                <Label for="name" className="BirThdaY-Label">Birth Date : </Label>
                                {!(fields.DocType === 1) ?
                                    <div className='total-month-and-year'>
                                        <div className="select-brith-year-div">
                                            <FormGroup>
                                                <Input type="select" className="select-year-brith" name='persianyear' onChange={this.Handelbirthday.bind(this)} defaultValue={review === true ? Number(this.props.data.BirthDate.substring(0, 4)) : 0}>
                                                    <option value={0} disabled >Year</option>
                                                    <this.getyearfa></this.getyearfa>
                                                </Input>
                                                <FormFeedback className={("BirthDate" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.BirthDate}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        <div className="select-brith-month-div">
                                            <FormGroup>
                                                <Input type="select" className="select-month-brith" name='persianmonth' onChange={this.Handelbirthday.bind(this)} defaultValue={review === true ? Number(this.props.data.BirthDate.substring(5, 7)) : 0}>
                                                    <option value={this.state.defaultyear} disabled >Month</option>
                                                    {FA_Month.map((month, i) =>
                                                        <option value={i + 1} key={i}>{month}</option>
                                                    )}
                                                </Input>
                                                <FormFeedback className={("BirthDate" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.BirthDate}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                    </div>
                                    :
                                    <div className='total-month-and-year'>
                                        <div className="select-brith-year-div">
                                            <FormGroup>
                                                <Input type="select" className="select-year-brith" name='latinyear' onChange={this.Handelbirthday.bind(this)} defaultValue={review === true ? Number(this.props.data.BirthDate.substring(0, 4)) : 0} >
                                                    <option value={this.state.defaultyear} disabled>Year</option>
                                                    <this.getyear></this.getyear>
                                                </Input>
                                                <FormFeedback className={("BirthDate" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.BirthDate}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        <div className="select-brith-month-div">
                                            <FormGroup>
                                                <Input type="select" className="select-month-brith" name='latinmonth' onChange={this.Handelbirthday.bind(this)} defaultValue={review === true ? Number(this.props.data.BirthDate.substring(5, 7)) : 0} >
                                                    <option value={this.state.defaultyear} disabled >Month</option>
                                                    {EN_Month.map((month, i) =>
                                                        <option value={i + 1} key={i}>{month}</option>
                                                    )}
                                                </Input>
                                                <FormFeedback className={("BirthDate" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.BirthDate}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                    </div>
                                }
                                <div className="select-brith-day-div">
                                    <FormGroup>
                                        <Input type="select" className="select-day-brith" name='birthdayday' onChange={this.Handelbirthday.bind(this)} defaultValue={review === true ? Number(this.props.data.BirthDate.substring(8, 10)) : 0} >
                                            <option value={0} disabled >Day</option>
                                            <this.getday></this.getday>
                                        </Input>
                                        <FormFeedback className={("BirthDate" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.BirthDate}</FormFeedback>
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col md={2} sm={6}>
                                {!(fields.DocType === 1) ?
                                    <FormGroup>
                                        <Label for="name">National ID : </Label>
                                        <Input
                                            invalid={("nationalId" in errors)}
                                            name="nationalId"
                                            type="text"
                                            placeholder="National ID"
                                            value={fields.nationalId !== null ? fields.nationalId : ''}
                                            onChange={this.handleChange.bind(this)}
                                            onBlur={this.handleBlur.bind(this)}
                                        />
                                        <FormFeedback style={{ color: "red" }}>{errors.nationalId}</FormFeedback>
                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Label for="name">Passport ID : </Label>
                                        <Input
                                            invalid={("passportId" in errors)}
                                            name="passportId"
                                            type="text"
                                            placeholder="Passport ID"
                                            value={fields.passportId !== null ? fields.passportId : ''}
                                            onChange={this.handleChange.bind(this)}
                                            onBlur={this.handleBlur.bind(this)}
                                        />
                                        <FormFeedback style={{ color: "red" }}>{errors.passportId}</FormFeedback>
                                    </FormGroup>
                                }
                            </Col>
                            {(fields.DocType === 1) ?
                                <Col md={5} sm={6} className='passport-expiredate' >
                                    <Label for="name" style={{ 'width': '100%' }}>Passport Expire : </Label>
                                    <div className='expire-main'>
                                        <div className="select-pass-expire">
                                            <FormGroup>
                                                <Input type="select" className="select-birth" name='expassyear' onChange={this.HandelPassportex.bind(this)} defaultValue={review === true ? Number(this.props.data.passportExpire.substring(0, 4)) : 0} >
                                                    <option value={0} disabled >Year</option>
                                                    <this.expgetyear></this.expgetyear>
                                                </Input>
                                                <FormFeedback className={("passportExpire" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.passportExpire}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className='expire-main'>
                                        <div className="select-pass-expire">
                                            <FormGroup>
                                                <Input type="select" className="select-birth" name='expassmonth' onChange={this.HandelPassportex.bind(this)} defaultValue={review === true ? Number(this.props.data.passportExpire.substring(5, 7)) : 0} >
                                                    <option value={0} disabled >Month</option>
                                                    {EN_Month.map((month, i) =>
                                                        <option value={i + 1} key={i}>{month}</option>
                                                    )}
                                                </Input>
                                                <FormFeedback className={("passportExpire" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.passportExpire}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className='expire-main'>
                                        <div className="select-pass-expire">
                                            <FormGroup>
                                                <Input type="select" className="select-birth" name='expassday' onChange={this.HandelPassportex.bind(this)} defaultValue={review === true ? Number(this.props.data.passportExpire.substring(8, 10)) : 0}>
                                                    <option value={0} disabled >Day</option>
                                                    <this.getday></this.getday>
                                                </Input>
                                                <FormFeedback className={("passportExpire" in errors) ? "d-block" : "d-none"} style={{ color: "red" }}>{errors.passportExpire}</FormFeedback>
                                            </FormGroup>
                                        </div>
                                    </div>
                                </Col> : ""}
                        </Row>
                    </CardBody>
                </Card>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className='Add-Passenger-Modal' >
                    <ModalHeader toggle={this.toggle}>Select Passenger</ModalHeader>
                    <ModalBody>
                        <MUIDataTable
                            data={this.state.rowData}
                            columns={this.state.columnDefs}
                            options={options}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <p>
                            Please Select Your Passenger.
                        </p>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    async addPassenger() {
        this.setState({ loading: true })
        const access_token = localStorage.getItem('api_token');
        console.log(access_token)
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            url: API_URL + 'passenger?api_token=' + access_token,
        };
        let response = await axios(options);
        console.log(response);
        if (response.status === 200) {
            const rowData = [];
            response.data.data.data.map((passenger, i) =>
                rowData.push([i + 1, passenger.firstname, passenger.lastname, <Button className="select-passenger-add" onClick={this.SetPassenger.bind(this, passenger)} >
                    Choose
                </Button>])
            )
            this.setState({
                modal: !this.state.modal,
                addPassenger: response.data.data.data,
                rowData,
                loading: false
            })
        } else {
            this.setState({
                loading: false
            })
            console.log('error')
        }
    }

    SetPassenger(passenger) {
        // console.log(passenger)
        let type = 1;
        if (passenger.type === "adult") { type = 1 }
        if (passenger.type === "child") { type = 2 }
        if (passenger.type === "infant") { type = 3 }
        this.setState({
            fields: {
                "PassengerType": type,//Adult = 1, Child = 2, Infant = 3
                "name": passenger.firstname,
                "family": passenger.lastname,
                "Gender": (passenger.gender === "f" ? 2 : 1),//Male = 1,Female = 2
                "BirthDate": passenger.birthday,
                "DocType": (passenger.country.id === 104 ? 4 : 1),//Passport = 1,NationalId = 4,
                "nationalId": (passenger.country.id === 104 ? passenger.national_id : null),
                "passportId": (passenger.country.id === 104 ? null : passenger.passport_no),
                "passportExpire": (passenger.country.id === 104 ? null : passenger.passport_expired),
                "DocIssuedCountry": passenger.country.un,//country iso code
                "id": passenger.id
            },
            modal: !this.state.modal,
        })
    }
    async Handelbirthday(e) {
        let value = e.target.value;
        let name = e.target.name;
        if (name === 'persianyear' || name === 'latinyear') {
            await this.setState({ birthdayyear: value })
        }
        if (name === 'persianmonth' || name === 'latinmonth') {
            if (value.length === 1) {
                await this.setState({ birthdaymonth: '0' + value })
            } else { await this.setState({ birthdaymonth: value }) }
        }
        if (name === 'birthdayday') {
            if (value.length === 1) {
                await this.setState({ birthdayday: '0' + value })
            } else {
                await this.setState({ birthdayday: value })
            }
        }
        let fields = this.state.fields;
        console.log(fields.DocIssuedCountry)
        if (fields.DocIssuedCountry === 'IR') {
            const brith = this.state.birthdayyear + '-' + this.state.birthdaymonth + '-' + this.state.birthdayday;
            fields["BirthDate"] = momentJalaali(brith, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
        } else {
            fields["BirthDate"] = this.state.birthdayyear + '-' + this.state.birthdaymonth + '-' + this.state.birthdayday;
        }

        this.setState({ fields })
    }
    async HandelPassportex(e) {

        let value = e.target.value;
        let name = e.target.name;
        if (name === 'expassyear') {
            await this.setState({ passexyear: value })
        }
        if (name === 'expassmonth') {
            if (value.length === 1) {
                await this.setState({ passexmonth: '0' + value })
            } else {
                await this.setState({ passexmonth: value })
            }
        }
        if (name === 'expassday') {
            if (value.length === 1) {
                await this.setState({ passexday: '0' + value })
            } else {
                await this.setState({ passexday: value })
            }
        }
        let fields = this.state.fields;
        fields["passportExpire"] = this.state.passexyear + '-' + this.state.passexmonth + '-' + this.state.passexday;
        this.setState({ fields })
    }
    handleBlur() {
        const { index } = this.props;
        // console.log(this.state.fields);
        // console.log(index);
        let fields = this.state.fields;
        if (fields.id <= 0) { fields.id = null }
        if (fields.DocType === 1) {
            fields.nationalId = null
        } else {
            // fields.passportExpire = null;
            fields.passportExpire = '';
            fields.passportId = '';
        }
        // console.log("fields");
        // console.log(fields);
        if (this.props.busform === true) {
            this.props.setbus(fields);
        } else {
            this.props.set(index, fields);
        }

    }
    handleChangeCountry(selectedOption) {
        // console.log(selectedOption.value);
        let fields = this.state.fields;

        fields["DocIssuedCountry"] = selectedOption.value;
        let DocType = 1;
        if (selectedOption.value === "IR") {
            DocType = 4;
        }
        fields["DocType"] = DocType;

        this.setState({
            fields, selectedOption
        });
        this.handleBlur();
    }

    handleDayChange(name, day) {
        // event.preventDefault();
        let fields = this.state.fields;


        fields[name] = dateFnsFormat(day, "YYYY-MM-DD");
        // fields[name] = day;
        this.setState({
            fields
        });
        this.handleBlur();
    }
    handleRegister(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) {
                // this.handleRequest();
                // console.log("all valid")
            }
        });
    }

    handleValidation(callback) {
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            errors["name"] = LangValidation.required;
        } else if (!validator.isLength(fields.name, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["name"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.family)) {
            formIsValid = false;
            errors["family"] = LangValidation.required;
        } else if (!validator.isLength(fields.family, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["family"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.BirthDate)) {
            formIsValid = false;
            errors["BirthDate"] = LangValidation.required;
        }
        if (fields.DocType === 1) {
            //passport
            if (validator.isEmpty(fields.passportId)) {
                formIsValid = false;
                errors["passportId"] = LangValidation.required;
            }
            if (validator.isEmpty(fields.passportExpire)) {
                formIsValid = false;
                errors["passportExpire"] = LangValidation.required;
            }
            errors["nationalId"] = null;
        } else {
            //national id
            if (validator.isEmpty(fields.nationalId)) {
                formIsValid = false;
                errors["nationalId"] = LangValidation.required;
            }
            errors["passportId"] = null;
            errors["passportExpire"] = null;
        }

        if (validator.isEmpty(fields.DocIssuedCountry)) {
            formIsValid = false;
            errors["DocIssuedCountry"] = LangValidation.required;
        }

        this.setState({ errors }, () => {
            return callback(formIsValid)
        });
    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        // console.log(this.state.errors);
        switch (target.name) {
            case 'name':
                if (validator.isEmpty(fields.name)) {
                    errors["name"] = LangValidation.required;
                } else if (!validator.isLength(fields.name, { min: 3, max: undefined })) {
                    errors["name"] = LangValidation.min;
                }
                break;
            case 'family':
                if (validator.isEmpty(fields.family)) {
                    errors["family"] = LangValidation.required;
                } else if (!validator.isLength(fields.family, { min: 3, max: undefined })) {
                    errors["family"] = LangValidation.min;
                }
                break;
            case 'BirthDate':
                if (validator.isEmpty(fields.BirthDate)) {
                    errors["BirthDate"] = LangValidation.required;
                }
                break;
            case 'nationalId':
                if (validator.isEmpty(fields.nationalId)) {
                    errors["nationalId"] = LangValidation.required;
                } else if (!validator.isLength(fields.nationalId, { min: 10, max: 11 })) {
                    errors["nationalId"] = LangValidation.min;
                } else if (!validator.isNumeric(fields.nationalId)) {
                    errors["nationalId"] = LangValidation.numeric;
                }
                break;
            case 'passportId':
                if (validator.isEmpty(fields.passportId)) {
                    errors["passportId"] = LangValidation.required;
                }
                break;
            case 'passportExpire':
                if (validator.isEmpty(fields.passportExpire)) {
                    errors["passportExpire"] = LangValidation.required;
                }
                break;
            case 'DocIssuedCountry':
                if (validator.isEmpty(fields.DocIssuedCountry)) {
                    errors["DocIssuedCountry"] = LangValidation.required;
                }
                let DocType = 1;
                if (target.value === "IR") {
                    DocType = 2;
                }
                fields["DocType"] = DocType;
                break;
            default:

        }
        this.setState({
            fields, errors
        });
    }
    expgetyear() {
        let i = new Date().getFullYear()
        let arr = []
        let y = i + 15
        for (i; i < y; i++) {
            arr.push(i)
        }
        return arr.map((y, key) => <option key={key} value={y}>{y}</option>)
    }
    getyear() {
        let i = new Date().getFullYear()
        let arr = []
        let y = i - 120
        for (i; i > y; i--) {
            arr.push(i)
        }
        return arr.map((y, key) => <option key={key} value={y}>{y}</option>)
    }
    getyearfa() {
        let i = new Date().getFullYear() - 622
        let arr = []
        let y = i - 120
        for (i; i > y; i--) {
            arr.push(i)
        }
        return arr.map((y, key) => <option key={key} value={y}>{y}</option>)
    }
    getday() {
        let i = 31
        let arr = []
        let y = 0
        for (i; i > y; i--) {
            arr.push(i)
        }
        return arr.map((y, key) => <option key={key} value={y}>{y}</option>)
    }




}
const mapStateToProps = (state) => {
    return {
        user: state.user.id
    }
};
export default connect(mapStateToProps, null)(PassengerForm);


// WEBPACK FOOTER //
// ./src/components/search/PassengerForm.js